namespace $ {
	
	// Инкрементится автоматически git-хуком hooks/pre-push при каждом push.
	export let $bog_music_version = 'v1.94'

}
